import "../css/index.scss";

import { attachScrollToElement, loadWithHash } from './modules/hashes';
import { runSliders } from './modules/sliderView';
import { header } from './modules/header';
import { thp } from './modules/contact-form7';
import { animateOnScroll } from './modules/animateOnScroll';

const runScripts = () => {
	attachScrollToElement();
	runSliders();
	thp();
	animateOnScroll();
};

const runScriptsOnLoad = () => {
	header();
}

if (document.readyState === 'interactive' || document.readyState === 'complete') {
	runScripts();
} else {
	window.addEventListener('DOMContentLoaded', () => {
		runScripts();
	});
}

if (document.readyState === 'complete') {
  runScriptsOnLoad();
} else {
  window.addEventListener('load', () => {
      runScriptsOnLoad();
  });
}


window.addEventListener("hashchange", loadWithHash, false);
window.addEventListener("load", loadWithHash, false);